<template>
  <div :class="`tooltip ${position}`">
    <slot></slot>
    <span class="tooltip__content">{{ content }}</span>
  </div>
</template>

<script>
export default {
  name: "tooltip",
  props: {
    content: String,
    position: String,
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  position: relative;
  display: inline-block;

  &__content {
    visibility: hidden;
    width: 200px;
    font-size: 12px;
    background-color: #808080;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    opacity: 0;
    transform: scale(0);
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.1);
  }

  &.top {
    .tooltip__content {
      bottom: 100%;
      left: 50%;
      margin-left: -60px;
    }
  }

  &.right {
    .tooltip__content {
      top: -5px;
      left: 110%;
    }
  }

  &.bottom {
    .tooltip__content {
      top: 100%;
      left: 50%;
      margin-left: -60px;
    }
  }

  &.left {
    .tooltip__content {
      top: -5px;
      right: 110%;
    }
  }

  &:hover {
    .tooltip__content {
      visibility: visible;
      opacity: 1;
      transform: scale(1);
    }
  }
}
</style>